function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackArrow = function SvgBackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m44 8.5-24 23 24 24",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  }));
};
export default SvgBackArrow;